import React, { memo, ReactNode, useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

interface Props {
  readonly children: ReactNode;
}

export default memo(function Layout({ children }: Props) {
  const [headerClass, setHeaderClass] = useState("");
  const [openMenu, setOpenMenu] = useState(false);
  function scrollNavigation() {
    const scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
  }, []);
  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header
          headerClass={headerClass}
          setOpenMenu={setOpenMenu}
          // layoutModeType={layoutModeType}
          // onChangeLayoutMode={onChangeLayoutMode}
        />
        <Sidebar openMenu={openMenu} />
        <div className="main-content">{children}</div>
      </div>
      {/*<RightSidebar />*/}
    </React.Fragment>
  );
});
